import React from 'react';
import Col from 'react-bootstrap/Col';
import Slider from 'react-slick';
import properties from '../../../modules/ajio-util/properties';
import { getImageNameForGTMPromotion } from '../../../modules/ga/gtmLandingPageMethods';
import BannerWrapper from '../../BannerWrapper';
import { replaceWithJioCDN } from '../../../utils/imageHandling';


class NativeFeatureHeroListCarousel extends React.Component {
  render() {
    const pagedetails = this.props.pagedetails;
    const heroListDetails = pagedetails.nativeFeatureHeroListDetails;
    const widgetType = pagedetails.typeCode;
    const sectionName = this.props.componentTitle
      ? this.props.componentTitle
      : pagedetails.typeCode;
    if (heroListDetails === undefined) {
      return null;
    }

    var slickSettings = {
      dots: false,
      arrows: true,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 2000,
      swipe: false,
      slidesToShow: 3,
      slidesToScroll: 1
    };

    const imageTextDetails = heroListDetails.map((list, i) => {
      return (
        <Col xs={4} className="gallery-section" key={i}>
          {list.imageDetails.map((image, j) => {
            let bannerImgUrl = '';
            bannerImgUrl =
              image.imageUrl.indexOf('?') == -1
                ? image.imageUrl
                : image.imageUrl.substr(0, image.imageUrl.indexOf('?'));
            return (
              <div key={i} className="image-section">
                <a
                  href={image.bannerUrlLink}
                  data-ga-event-category="bannerTap"
                  data-ga-event-action={`${sectionName}/${image.componentPosition}/${widgetType}`}
                  data-ga-event-label={`${bannerImgUrl}/${image.bannerPosition}`}
                  data-gtm-bnr-position={`${image.componentPosition}`}
                  data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(image.imageUrl) || ''}`}
                  data-gtm-bnr-id={`${image.uId || ''}`}
                >
                  <img src={`${replaceWithJioCDN(image.imageUrl)}`} className="img-animate" />
                </a>
              </div>
            );
          })}
          {list.categoryTextLinkDetails ? (
            <div className="text-section">
              {list.categoryTextLinkDetails.map((text, j) => {
                return (
                  <a href={text.categoryTextUrlLink} key={j}>
                    {text.categoryText}
                  </a>
                );
              })}
            </div>
          ) : null}
        </Col>
      );
    });
    let cDetails;
    if (heroListDetails.length > 3) {
      cDetails = (
        <Slider {...slickSettings} ref="slick">
          {imageTextDetails}
        </Slider>
      );
    } else {
      cDetails = imageTextDetails;
    }
    const classNames = `gallery-com${heroListDetails.length <= 3 ? ' row' : ''}`;

    return <div className={classNames}>{cDetails}</div>;
  }
}

export default BannerWrapper(NativeFeatureHeroListCarousel);
